<script>
export default {
  name: 'Pricing'
}
</script>

<template>
  <!--START PRICING-->
  <section class="section bg-light" id="pricing">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 order-1 order-lg-2">
          <div class="features-box mt-5 mt-lg-0">
            <h3>El Franquiciado debe cumplir con ciertas características para optar por nuestra franquicia</h3>
            
            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
              <li class>Comprender y <span style="color:#16407c;"><b>compartir los valores</b></span> de nuestra empresa</li>
              <li class>Hombre o mujer <span style="color:#16407c;"><b>que trabaje de manera activa en el local</b></span> o en la administración del negocio</li>
              <li class>Con conocimientos e inclinación hacia temas de <span style="color:#16407c;"><b>atención al cliente, administración y marketing</b></span></li>
              <li class>Que reconozca y <span style="color:#16407c;"><b>valore el modelo de negocio</b></span> de EMILIO BENZO S.A</li>
              <li class><span style="color:#16407c;"><b>Respetuoso/a,</b></span> con buen manejo de las relaciones humanas</li>
              <li class>Capaz de <span style="color:#16407c;"><b>interpretar la cultura</b></span> de la Empresa</li>
              <li class><span style="color:#16407c;"><b>Disponibilidad horaria</b></span> para atender el negocio en los horarios establecidos</li>
              <li class>Dispuesto a <span style="color:#16407c;"><b>seguir normas y aportar ideas.</b></span></li>
              <li class>Contar con las <span style="color:#16407c;"><b>garantías necesarias</b></span> para respaldar el negocio (aval bancario, propiedades o fiador solidario), que puedan garantizar y cubrir también las obligaciones con los proveedores</li>
              <li class><span style="color:#16407c;"><b>Capital necesario</b></span> para iniciar las operaciones</li>            
            </ul>
            
          </div>
        </div>
        <div class="col-lg-5 order-2 order-lg-1">
          <div class="features-img mx-auto mr-lg-0">
            <img src="@/assets/images/f.1.png" alt="macbook image" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--ENd PRICING-->
</template>